import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { installSafeToast } from "@/lib/safeToast";

// Jun 2026 · Harden every toast against object-shaped API error bodies
// before any component can fire one. See lib/safeToast.js.
installSafeToast();

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");

// If the page was prerendered (build-time Puppeteer snapshot of the public
// marketing routes), hydrate the existing markup instead of throwing it away.
// In dev and on non-prerendered routes the container is empty, so we mount
// normally.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
